import styled from 'styled-components';
import { fontFamilyBody } from './helpers/mixins';

export const ListItem = styled.li`
  ${fontFamilyBody};
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: normal;
`;



// WEBPACK FOOTER //
// ./src/styles/ListItem.js